declare module '@mui/material/styles' {
  interface BreakpointOverrides {
    xs: true;
    sm: true;
    lsm: true;
    md: true;
    lmd: true;
    lg: true;
    lx: true;
    xl: true;
    xxl: true;
    xxxl: true;
  }
}

export const breakpointsValues = {
  xs: 0,
  sm: 600,
  lsm: 768,
  md: 900,
  lmd: 1050,
  lg: 1200,
  lx: 1368,
  xl: 1536,
  xxl: 1920,
  xxxl: 2600,
};
